          <template>
    <v-card class="transparent stickytopconscious" width="100%" height="100%">
    <!-- <v-card class="transparent"> -->
      <!-- <div  class="my-10"> -->
        <v-card class="transparent" width="100%" flat>
            <v-parallax
            height="150"
            src="@/assets/Tribunes_Parallax_(Invert).jpeg"
            >
              
              <v-row
              align="center"
              justify="center"
            >
              <v-col class="parallaxbgcontentgrad text-center" cols="12">
                <h1 class="display-2 font-weight-thin mb-4">Financial</h1>
                <h4 class="headline">FREEDOM</h4>
              </v-col>
            </v-row>
            </v-parallax>            
            </v-card>
            <!-- </div>-->
      <!-- <div  class="my-10"> -->
        <v-card color="#FFFFFF" width="100%" flat>
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                    <h2 class="primary--text mx-1 my-3" align="center">Voluntary Sequestration</h2>          
                <div>This is High Court application, intended for individuals who's financial situation has deteriorated in such a way that they are no longer capable to meet their monthly obligations to credit providers, thus seeking a fresh start and financial freedom.&nbsp;</div><div><br></div><div>It is also the only process that may overrule or supersede ANY other legal action already taken. This process is also known as a friendly sequestration, in which numerous benefits are involved due to the fact that it is brought voluntarily. This is a straight forward process that has been around for many years,&nbsp; although due to the numerous amount of these applications nowadays, a lot has also changed. So what can be expected?&nbsp;</div><div><br></div><div>A powerful, swift and effective process with a supportive team backing and acting in your best interests!</div><div><br></div><div>Debt is written off with a minimal amount contribution as compensation to creditors, as per the Insolvency Law. Once we embark on an application, applicant may provide their creditors with our contact information should they contact you, so that we may confirm the application and release the necessary information and documentation. They will no longer be applicant's responsibility, as applicant will no longer need to liaise with them or subject themselves to further harassment.&nbsp;</div><div><br></div><div>After a few months of receipt of application, the court documents will be ready and the application</div><div><br></div><div>will then be presented in the High court by one of our lawyers, acting on applicant's behalf. After the application was successfully granted in court, we will obtain the court order. The curator will then be appointed soon after, to finalize the insolvent estate. The curator will act in the the applicant's best interest and liaise with the applicant on a regular basis. The curator will be under obligation to call upon creditors meeting, so creditors may then be granted their opportunity to insert their claim against the insolvent estate.&nbsp;</div><div><br></div><div>Once creditors have proven their claim against the estate, curator will then service these claims in accordance with what is available for distribution. Once an individual has applied for this process, they will cease any further payments towards the creditors, and utilize their funds for the process.&nbsp;</div><div><br></div><div>You will NOT lose any fully paid assets, as we may assist with what is called a cash sequestration (Paying off contribution amount in instalments). Due to this fact, an applicant can speedily build up their new estate with regards to the future.&nbsp;</div><div><br></div><div>The process takes approximately 2 years, after which an applicant may then apply for rehabilitation, in order to clear and restore their name with the credit bureaus.&nbsp;</div><div><br></div><div>This is and always will be the most swift and efficient process of becoming DEBT FREE!!!</div><div>&nbsp;</div><div><br></div><div><u>Benefits of Voluntary Sequestration:</u></div><div><br></div><div><ul><li>Process applicable on ALL Debt and written off</li><li>Legal action prevented and overruled</li><li>High Court application based on the Insolvency Law</li><li>Creditors are No longer asked consent or cooperation but rather Instructed by the Master of the High Court</li><li>Salary does not get attached</li><li>Creditors are dealt with on your behalf and no longer your responsibility</li><li>Creditors may no longer demand payments and may no longer pursue</li><li>Minimal Contribution amount payable in monthly instalments of up to 25 months</li><li>Employers are not informed, since it is a private matter</li><li>Total process takes approximately 2 years to conclude</li><li>Result = Clean break from the past and Fresh New Start awaits!</li></ul></div><div>&nbsp;</div><div><br></div><div>For more information, contact us, or submit your application from the Home page</div><br><br><br><br><br><br>
                </v-flex>
                </v-layout>            
            </v-card>
            <!-- </div>-->
      <!-- <div  class="my-10"> -->
        <v-card class="transparent" width="100%" flat>
        <v-img src="@/assets/Helping_Hand.jpeg"  width="100%" height="300">
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                </v-flex>
                </v-layout>
        </v-img>            
            </v-card>
            <!-- </div>-->
            
        </v-card> 
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'


export default {
  name: 'VoluntarySequestration',
  metaInfo: {
    title: 'Voluntary Sequestration Service - Tribunes SA',
    meta: [
      {
        name: 'description',
        content: `Unlock financial freedom with our High Court process. Swift, effective, and debt-free in 2 years. Expert guidance. Click to learn more!`
      },
      {
        name: 'keywords',
        content: 'Voluntary Sequestration, Debt Relief, Tribunes SA'
      }
    ]
  },
    components: {
        },
    data() {
    return {      
      UserRecord: {},
      rules: {
        youtubeurl: value => {
            const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            return pattern.test(value) || "Not a Youtube Video Link.";
          },
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          },
          url: value => {
            const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); 
            return urlpattern.test(value) || "Invalid Link.";
          }
        },
    }
    },
    computed:{
      userLoggedIn () {
      return this.$store.getters.user
    },
      
      

    },
    mounted () {
  window.scrollTo(0, 0)
},
    created(){
      this.FocusedViewToggle()
      this.IntranetViewToggle()
      this.CheckUser()

    },
    
    methods: {
      IntranetViewToggle(){
        this.$emit('IntranetViewToggle',false)
      },
      FocusedViewToggle(){
        this.$emit('FocusedViewToggle',false)
      },
      async CheckUser(){
            let vm = this
            await firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                  db.collection('users').doc(user.uid).onSnapshot(snapshot => {
              var userdetails = snapshot.data()

              vm.UserRecord = userdetails
              vm.UserRecord.id = user.uid
              console.log(vm.UserRecord)
                  })
                }
                else{
                }
            })
        },
          DateFormatter(date){
            if(date){
            let yearstring = date.split('-')[0]
              let monthstring = date.split('-')[1]
              let daystring = date.split('-')[2]
              let yearnumber = Number(yearstring)
              let monthnumber = Number(monthstring)
              let daynumber = Number(daystring)
              return new Date(yearnumber, monthnumber-1, daynumber)
              }
            else{
              return null
            }
          },

    }    
}
</script>

<style>
.parallaxbgcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.5), rgb(189,199,209, 1));
}
.transoutline{
    border: 1px solid black;
    background-color:pink
    /* color: rgba(255,255,255,0.05) */
}
.v-card--reveal {
    /* background-color: rgba(176, 7, 255, 0.5); */
  background-color: rgba(255, 193, 7, 0.75);
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index:10
}

.iconoutline{
  text-shadow: 0 0 3px #FF0000;
}
</style>

        
            
        